module.exports = __webpack_public_path__ + "img/MCD_Instore_Big_Teaser_01.4ea82ab4.jpg";